import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import displayINRCurrency from '../helpers/displayCurrency';
import { toast } from 'react-toastify';
import { FaTag } from 'react-icons/fa6';
import AdminBrandCardProduct from '../components/AdminBrandProduct';
import AdminAlterCardProduct from '../components/AdminAlterProduct';
import { MdModeEditOutline } from 'react-icons/md';
import { MdDelete } from 'react-icons/md';
import AdminEditProduct from '../components/AdminEditProduct';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import defaultImage from '../assest/DAWACO_Icon.png'; 



const AdminProductDetails = () => {
  const [data, setData] = useState({
    productName: "",
    brandName: "",
    category: "",
    productImage: [],
    description: "",
    price: "",
    sellingPrice: "",
    quantity: 0
  });
  const [currentQuantity, setCurrentQuantity] = useState(1);
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const productImageListLoading = new Array(4).fill(null);
  const [activeImage, setActiveImage] = useState("");
  const [zoomImageCoordinate, setZoomImageCoordinate] = useState({ x: 0, y: 0 });
  const [zoomImage, setZoomImage] = useState(false)
  const navigate = useNavigate();
  const [editProduct, setEditProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const user = useSelector(state => state?.user?.user);

  const AdminfetchProductDetails = async () => {
    setLoading(true);
    const response = await fetch(SummaryApi.adminProductDetails.url, {
      method: SummaryApi.adminProductDetails.method,
      headers: {
        "content-type": "application/json"
      },
      credentials:'include',
      body: JSON.stringify({ productId:params?.id,type:"Medicine"})
    });
    setLoading(false);
    const dataResponse = await response.json();
    setData(dataResponse?.data);
    if (dataResponse?.data === null || dataResponse?.data === undefined) {
      navigate('/admin-home');
  }
    setActiveImage(dataResponse?.data?.productImage[0]);
    setCurrentQuantity(1); 
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.ADMIN ) {
        
        navigate("/");
        setLoading(false);
      } 
      else if(user?.type==="Cosmetic"){
        navigate('/admin-cosmetic-home')
        setLoading(false);

      }
      else if(user?.type==="Admin"){
        navigate('/admin-panel/all-users');
        setLoading(false);

      }
      else {
        setLoading(false);
        clearTimeout(loadingTimeout)
        AdminfetchProductDetails();
      }
    } 


    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

 

  const handleMouseEnterProduct = (imageURL) => {
    setActiveImage(imageURL);
  };

  const handleZoomImage = useCallback((e) => {
    setZoomImage(true);
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height;
    setZoomImageCoordinate({ x, y });
  }, [zoomImageCoordinate]);

  const handleLeaveImageZoom = () => {
    setZoomImage(false);
  };

 

  const isOutOfStock = data?.quantity <= 0;

  const openEditProduct = (product) => {
    setSelectedProduct(product);
    setEditProduct(true);
};

const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setConfirmationVisible(true);
};

const deleteFromCart = async (id) => {

  const response = await fetch(SummaryApi.deleteFromCart.url, {
    method: SummaryApi.deleteFromCart.method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      productId: id,
    }),
  });

  const responseData = await response.json();

  

};

const handleDelete = async (id,type) => {
    try {
        await deleteFromCart(id);
        const response = await fetch(SummaryApi.deleteProduct.url, {
          method: SummaryApi.deleteProduct.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            type:type,
          }),
        });

        const responseData = await response.json();

        if (responseData.success) {
            toast.success('تم حذف المنتج بنجاح');
            setConfirmationVisible(false);
            navigate('/admin-home')
        } else {
            toast.error('فشل في حذف المنتج');
        }
    } catch (error) {
        toast.error('حدث خطأ اثناء حذف المنتج');
    }
};


if (loading) {
  return (
    <div className="flex justify-center items-center h-screen">
      <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
    </div>
  );
}
  return (
    <div className='container mx-auto p-4'>
      <div className='min-h-[200px] flex flex-col lg:flex-row gap-4'>
        {/* Product Image */}
        <div className='h-96 flex flex-col lg:flex-row-reverse gap-4'>
          <div className='h-[300px] w-[300px] lg:h-96 lg:w-96 bg-slate-200 relative p-2'>
            <img
              src={activeImage||defaultImage}
              className='h-full w-full object-scale-down mix-blend-multiply'
              onMouseMove={handleZoomImage}
              onMouseLeave={handleLeaveImageZoom}
            />
            {/* Product Zoom */}
            {zoomImage && (
              <div className='hidden lg:block absolute min-w-[500px] overflow-hidden min-h-[400px] bg-slate-200 p-1 -right-[510px] top-0'>
                <div
                  className='w-full h-full min-h-[400px] min-w-[500px] mix-blend-multiply scale-150'
                  style={{
                    background: `url(${activeImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: `${zoomImageCoordinate.x * 100}% ${zoomImageCoordinate.y * 100}%`
                  }}
                />
              </div>
            )}
          </div>

          <div className='h-full'>
            {loading ? (
              <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
                {productImageListLoading.map((el, index) => (
                  <div className='h-20 w-20 bg-slate-200 rounded animate-pulse' key={"loadingImage" + index}></div>
                ))}
              </div>
            ) : (
              <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
                {data?.productImage?.map((imgURL, index) => (
                  <div className='h-20 w-20 bg-slate-200 rounded p-1' key={imgURL}>
                    <img
                      src={imgURL}
                      className='w-full h-full object-scale-down mix-blend-multiply cursor-pointer'
                      onMouseEnter={() => handleMouseEnterProduct(imgURL)}
                      onClick={() => handleMouseEnterProduct(imgURL)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Product Details */}
        {loading ? (
          <div className='grid gap-1 w-full'>
            <p className='bg-slate-200 animate-pulse h-6 lg:h-8 w-full rounded-full inline-block'></p>
            <h2 className='text-2xl lg:text-4xl font-medium h-6 lg:h-8 bg-slate-200 animate-pulse w-full'></h2>
            <p className='capitalize text-slate-400 bg-slate-200 min-w-[100px] animate-pulse h-6 lg:h-8 w-full'></p>
            <div className='text-blue-600 bg-slate-200 h-6 lg:h-8 animate-pulse flex items-center gap-1 w-full'></div>
            <div className='flex items-center gap-2 text-2xl lg:text-3xl font-medium my-1 h-6 lg:h-8 animate-pulse w-full'>
              <p className='text-blue-600 bg-slate-200 w-full'></p>
              <p className='text-slate-400 line-through bg-slate-200 w-full'></p>
            </div>
            <div className='flex items-center gap-3 my-2 w-full'>
              <button className='h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></button>
              <button className='h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></button>
            </div>
            <div className='w-full'>
              <p className='text-slate-600 font-medium my-1 h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></p>
              <p className='bg-slate-200 rounded animate-pulse h-10 lg:h-12 w-full'></p>
            </div>
          </div>
        ) : (
          <div className='flex flex-col gap-1'>
            <p className='bg-blue-200 text-blue-600 px-2 rounded-full inline-block w-fit'>{data?.brandName}</p>
            <h2 className='text-2xl lg:text-4xl font-medium'>{data?.productName}</h2>
            <p className='capitalize text-400 font-medium'> {data?.activePharmaceuticalIngredient} : الماده الفعالة</p>
            <p className='capitalize text-400 font-medium'> {data?.quantity} : الكمية</p>
              <p className='capitalize text-400 font-medium'>
            النوع : {data?.status === "Promo Pack" ? "العروض المجمعة" :
          data?.status === "New Arrival" ? "منتجات حديثة الوصول" :
          data?.status === "Sale" ? "التخفيضات" :
          data?.status} 
        </p>

            
            
            {data?.sellingPrice > 0 && (
                            <div className='absolute top-2 right-2 bg-blue-700 text-white px-3 py-1 rounded-full text-sm flex items-center'>
                                <FaTag className='mr-1' />
                                <span>{`${Math.round(((data?.price - data?.sellingPrice) / data?.price) * 100)}% خصم`}</span>
                            </div>
                        )}
            <div className='flex items-center gap-2 text-2xl lg:text-3xl font-medium my-1'>
            {data?.sellingPrice > 0 ? (
                                                <>
                                                    <p className='text-blue-800 font-medium'>{displayINRCurrency(data?.sellingPrice)}</p>
                                                    <p className='text-slate-500 line-through'>{displayINRCurrency(data?.price)}</p>
                                                    <div className=' bg-blue-600 text-white px-3 py-1 rounded-full text-sm flex items-center'>
                                <FaTag className='mr-1' />
                                <span>{`${Math.round(((data?.price - data?.sellingPrice) / data?.price) * 100)}% خصم`}</span>
                            </div>
                                                </>
                                            ) : (
                                                <p className='text-blue-800 font-medium'>{displayINRCurrency(data?.price)}</p>
                                            )}
            </div>
            <div className='absolute top-2 right-10 p-2 bg-blue-100 hover:bg-blue-800 rounded-full hover:text-white cursor-pointer' onClick={() => openEditProduct(data)}>
                                        <MdModeEditOutline />
                                    </div>
                                    <div className='absolute top-2 right-2 p-2 bg-red-100 hover:bg-red-800 rounded-full hover:text-white cursor-pointer' onClick={() => handleDeleteClick(data)}>
                                        <MdDelete />
                                    </div>
            {isOutOfStock ? (
              <div className='my-4'>
                <p className='text-red-600 font-medium'>غير متاح حاليا في المخزن</p>
              </div>
            ) : (
              <></>
            
            )}

            <div className='w-full'>
              <p className='text-slate-600 font-medium my-1'>الوصف</p>
              <p>{data?.description}</p>
            </div>
             {/* Buttons Section */}
  <div className='flex gap-4 mt-4'>
    <button 
      className='bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' 
      onClick={() => openEditProduct(data)}>
      <MdModeEditOutline className='mr-2' />
      تعديل المنتج
    </button>
    <button 
      className='bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600' 
      onClick={() => handleDeleteClick(data)}>
      <MdDelete className='mr-2' />
      حذف المنتج
    </button>
  </div>
          </div>
        )}
      </div>

      <AdminBrandCardProduct type={"Medicine"} category={data?.brandName} id={data?._id} heading={data?.brandName+ " ايضا من"} fetchdata={AdminfetchProductDetails}/>

      <AdminAlterCardProduct type={"Medicine"} activePharmaceuticalIngredient={data?.activePharmaceuticalIngredient} id={data?._id} heading={"منتجات بديلة"} fetchdata={AdminfetchProductDetails}/>
      
             {/* Confirmation Dialog */}
{confirmationVisible && (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
        <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative'>
            <h3 className='text-lg font-semibold mb-4'> ؟ {productToDelete?.productName} هل انت متاكد من حذف  </h3>
            <div className='flex gap-4'>
                <button className='bg-red-500 text-white px-4 py-2 rounded' onClick={() => handleDelete(productToDelete._id,"Medicine")}>نعم</button>
                <button className='bg-gray-300 px-4 py-2 rounded' onClick={() => setConfirmationVisible(false)}>لا</button>
            </div>
            {/* Optional Close Button */}
            <button 
                className='absolute top-2 right-2 text-gray-500 hover:text-gray-700'
                onClick={() => setConfirmationVisible(false)}
            >
                &times;
            </button>
        </div>
    </div>
)}


            {/* Modal for Editing Product */}
            { editProduct&& (
                <div className='fixed inset bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl relative'>
                        <AdminEditProduct userType = {"Medicine"} productData={selectedProduct} onClose={() => setEditProduct(false)} fetchdata={AdminfetchProductDetails} condition={false} />
                    </div>
                </div>
            )}
    </div>
  );
};

export default AdminProductDetails;
